<div class="package-details-settings-panel layout-column" appBringozIdGenerator="package-details-settings-panel">
  <div class="flex layout-column overflow-auto">
    <section>
      <app-bringoz-table-columns-settings [columns]="settings().columns"
                                          [isOpen]="true"
                                          columnsTranslationPrefix="PACKAGE_DETAILS_COLUMNS"
                                          (columnsChange)="onColumnsChange($event)">
      </app-bringoz-table-columns-settings>
    </section>
    <section>
      <bz-card [padded]="false" class="customized-columns" appBringozIdGenerator="package-details-settings-dynamic-columns">
        <div class="layout-row layout-align-start-center card-title">
          <span class="flex br-body-2 gray-100">{{ 'Customized Packages Table Columns' | translate }}</span>
          <span container="body" placement="left" [ngbTooltip]="'Show More' | translate">
            <bz-icon [icon]="chevronUp"></bz-icon>
          </span>
        </div>
        <bz-divider></bz-divider>
        <div class="layout-row layout-wrap layout-align-start-center columns-container">
          @for (column of settings().packageDynamicColumns; track column.id; let i = $index) {
            <div class="flex-50 layout-row">
              <bz-switch *ngxPermissionsOnly="column.permission"
                         appBringozIdGenerator="package-details-settings-dynamic-column-switch"
                         size="sm"
                         [checked]="!!column.enabled"
                         (checkedChange)="onPackageColumnToggle(i, $event)">
                <span class="br-body-2">{{ column.title }}</span>
              </bz-switch>
            </div>
          }
        </div>
      </bz-card>
    </section>
  </div>
  <bz-divider></bz-divider>
  <div class="layout-row layout-align-start-center padding-10">
    <bz-button variant="tertiary" appBringozIdGenerator="package-details-settings-reset-button" (clicked)="onReset()">
      {{ 'Reset' | translate }}
    </bz-button>
    <span class="flex"></span>
    <bz-button variant="outline" tone="primary" class="margin-right-5" appBringozIdGenerator="package-details-settings-cancel-button" (clicked)="onCancel()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <bz-button variant="outline" tone="secondary" appBringozIdGenerator="package-details-settings-submit-button" (clicked)="onSubmit()">
      {{ 'Submit' | translate }}
    </bz-button>
  </div>
</div>
